
import Vue from "vue";
import TabButton from "@/components/atoms/TabButton.vue";
import closeIcon from "@/assets/icons/close-icon.svg";
import assistIcon from "@/assets/icons/assist-icon.svg";
import historyIcon from "@/assets/icons/history-icon.svg";

interface Tab {
  id: string;
  label: string;
  iconSrc: string;
  iconAlt: string;
}

export default Vue.extend({
  name: "TabNavigation",
  components: {
    TabButton,
  },
  props: {
    activeTab: {
      type: String,
      default: "assist",
    },
  },
  data() {
    return {
      tabs: [
        {
          id: "close",
          label: "閉じる",
          iconSrc: closeIcon,
          iconAlt: "閉じるアイコン",
        },
        {
          id: "assist",
          label: "アシスト依頼",
          iconSrc: assistIcon,
          iconAlt: "肉球アイコン",
        },
        {
          id: "history",
          label: "過去ログ",
          iconSrc: historyIcon,
          iconAlt: "証明書アイコン",
        },
      ] as Tab[],
    };
  },
  methods: {
    handleTabClick(tabId: string): void {
      this.$emit("tab-change", tabId);
    },
  },
});
